import React from 'react';
import {estimateTypes, ScotType} from '../../util/uiconstants';
import {alphanumericSort} from './accounts';

export const getScotsSlice = (state) => state.scots;

export const getScotsPagingOptions = (state) => {
	return {
		page: getScotsSlice(state)?.page,
		pages: getScotsSlice(state)?.pages
	};
};

export const getScotsForEstimateGridDetail = (slice, doc, labels) => {
	let formattedScotData = [];
	let documents = Object.values(doc?.byId);
	if (slice?.allIds?.length > 0) {
		let scots = Object.values(slice?.byId);
		for (const scot of scots) {
			let scotsEstimates = [];

			if (scot?.relatedRisks?.length > 0) {
				//Create child rows for scots
				scot?.relatedRisks?.map((estimate) => {
					if (Object.values(estimateTypes).includes(estimate?.riskTypeId)) {
						let filterDocs = documents.filter((f) => f.smartEvidenceSourceId === estimate?.riskId);
						let mappedDocuments = [];

						filterDocs.map((doc) => {
							mappedDocuments.push({
								documentName: doc.documentName,
								documentTypeID: doc.documentTypeId,
								fileExt: doc.fileExt,
								id: doc.id,
								riskId: estimate?.id
							});
						});
						scotsEstimates.push({
							estimateName: estimate?.riskName,
							['id']: estimate?.id,
							['documents']: mappedDocuments
							// onClick: () => console.log('clicked ' + estimate?.riskName)
						});
					}
				});
			}
			// Sort estimates by name
			scotsEstimates.sort(alphanumericSort);
			//Create parent scot row
			formattedScotData.push({
				[labels.sCOTsAndRelatedEstimates]: scot?.scotName,
				scotName: scot?.scotName,
				scotStrategy: scot?.strategyTypeId,
				scotType: scot?.scotTypes,
				estimateCount: scotsEstimates?.length,
				estimateNames: scotsEstimates,
				parentRow: true,
				hasEstimate: scot?.scotTypes?.length > 0 && scot?.scotTypes?.includes(ScotType.Estimation)
			});
		}
	}
	// Sort scots by name
	return _.orderBy(formattedScotData, [(scot) => scot?.scotName?.toString()?.toLowerCase()], ['asc']);
};
